import { ClientIDType } from '../../types';
import { I18n } from '../../wrappers';
export class ClientLocalizationMe {
    client;
    constructor(client) {
        this.client = client;
    }
    static idTypes() {
        return [
            { id: ClientIDType.tax_id_number, text: I18n.t('clients.id_types.tax_id_number') + ' / ' + I18n.t('clients.id_types.personal_id_number'), prefix: null },
            { id: ClientIDType.personal_id_number, text: I18n.t('clients.id_types.personal_id_number'), prefix: null },
            { id: ClientIDType.passport_number, text: I18n.t('clients.id_types.passport_number'), prefix: null },
            { id: ClientIDType.vat_number, text: I18n.t('clients.id_types.vat_number'), prefix: null },
            { id: ClientIDType.tax_number, text: I18n.t('clients.id_types.tax_number'), prefix: null },
            { id: ClientIDType.social_security_number, text: I18n.t('clients.id_types.social_security_number'), prefix: null },
        ];
    }
    isDiplomat() {
        return !!this.client.tax_id_card_number;
    }
    isLocalCountry() {
        return !this.client.country || this.client.country === 'MNE';
    }
    isValid() {
        if (!this.client.isLocalCountry()) {
            return !!this.client.name
                && !!this.client.id_type
                && !!this.client.id_number
                && !!this.client.address
                && !!this.client.city;
        }
        return !!this.client.name && (!!this.client.tax_id_number || (!!this.client.id_number && !!this.client.id_type));
    }
}
const ClientLocalizationMeStatic = ClientLocalizationMe;
//# sourceMappingURL=ClientLocalizationMe.js.map